module.exports = __webpack_public_path__ + "static/landingImg-e0cfb20cfb4a6f2149b2c83979ab3b2a.svg";